import requestApi from "@/utils/requestApi";
import NListGenerato from "@nxin/nxin-ui-pc/NListGenerato/NListGenerato.vue";
import requestSC from "@/utils/requestSC";
import GenerateStatement from "../components/generateStatement.vue";

export default {
  components: {
    nListGenerato: NListGenerato,
    GenerateStatement,
  },

  data() {
    return {
      form: {
        shopNameLike: "",
        supplierLinkManNameOrPhoneLike: "",
        payCheckStatus: "",
      },
      theadData: [
        {
          prop: "payCheckMonth",
          label: "对账日期",
        },
        {
          prop: "supplierShopName",
          label: "供应商名称",
        },
        {
          prop: "supplierLinkManName",
          label: "联系人",
        },
        {
          prop: "supplierLinkManPhone",
          label: "联系方式",
        },
        {
          prop: "payCheckStatusCn",
          label: "状态",
        },
        {
          prop: "purchaseOperateName",
          label: "操作人",
        },
        {
          prop: "purchaseOperateTime",
          label: "操作时间",
        },
        {
          prop: "fn",
          label: "操作",
          type: "custom",
        },
      ],
      tbodyData: [],
      total: 0,
      pageNum: 1,
      pageSize: 10,
      searchData: [
        {
          tag: "autocomplete",
          prop: "shopNameLike",
          value: "",
          label: "供应商名称",
          options: [],
          multiple: true,
          placeholder: "请输入名称关键字",
        },
        {
          tag: "input",
          prop: "supplierLinkManNameOrPhoneLike",
          value: "",
          label: "联系人",
          placeholder: "请输入姓名/手机号",
        },
        {
          tag: "select",
          prop: "payCheckStatus",
          value: "",
          label: "状态",
          options: [
            {
              value: "0",
              label: "待确认",
            },
            {
              value: "1",
              label: "已对账",
            },
          ],
          placeholder: "请选择",
        },
      ],
      buttonFunctionData: [
        {
          tag: "button",
          icon: "el-icon-plus",
          prop: "add",
          type: "primary",
          label: "发起对账",
        },
        {
          tag: "button",
          icon: "el-icon-download",
          prop: "export",
          type: "primary",
          label: "导出",
        },
      ],
      supplierList: [],
    };
  },

  created() {
    requestApi.post(`sctrading/purchase/purchasepaycheckrecord/selSupplierList`, {}).then((res) => {
      if (res.code == "0") {
        this.supplierList = res.data;
        this.searchData[0].options = res.data.map((item) => ({
          value: item.shopName,
          label: item.shopName,
        }));
      }
    });
  },

  mounted() {
    const body = document.querySelector("body");
    body.classList.add("seller-style");
    this.loadData();
  },

  methods: {
    async loadData() {
      const loading = this.$loading({
        lock: true,
        text: "加载中...",
      });

      const { msg, code, data } = await requestApi.post(`sctrading/purchase/purchasepaycheckrecord/selPage`, {
        ...this.form,
        pageNum: this.pageNum,
        pageSize: this.pageSize,
      });
      loading.close();

      if (code == "0") {
        this.total = Number(data.total);
        this.tbodyData = data.list;
      } else {
        this.$message.error(msg);
      }
    },

    sizeChange(size) {
      this.pageSize = size;
      this.pageNum = 1;
      this.loadData();
    },
    currentChange(current) {
      if (Number.isNaN(Number(current))) {
        return;
      }
      this.pageNum = current;
      this.loadData();
    },

    resetForm() {
      this.$refs.form.resetFields();
    },
    searchSubmit(form) {
      this.form = form;
      this.loadData();
    },

    async viewPdf(slotProps) {
      const { row } = slotProps;
      console.log("row", row);
      if (row.payCheckStatus) {
        this.$open(slotProps.row.contractUrl);
      } else {
        const loading = this.$loading({
          lock: true,
          text: "加载中...",
        });

        const { msg, code, data } = await requestSC.post(`rest/contract/previewAgreement/v2`, {
          busId: row.id,
          invoiceContractType: "payCheck",
        });
        loading.close();

        if (code == "0") {
          this.$open(data[0].contractUrl, { title: data[0].templateName });
        } else {
          this.$message.error(msg);
        }
      }
    },

    handleAdd() {
      this.$refs.generateStatement.open();
    },

    async handleExport() {
      const loading = this.$loading({
        lock: true,
        text: "加载中...",
      });

      const { msg, code, data } = await requestApi.post(`sctrading/purchase/purchasepaycheckrecord/export`, this.form);
      loading.close();

      if (code == "0") {
        this.$open(data.url, { target: 1 });
      } else {
        this.$message.error(msg);
      }
    },
  },
};
